import {Container, Grid, Card, CardContent, Typography } from "@material-ui/core"

// import { Container, Grid, Card, CardContent, Typography } from "@mui/material";
import { MusicNote, Chat, Edit, CheckCircle, CloudUpload } from "@material-ui/icons";

const steps = [
  { icon: <Chat fontSize="large" />, title: "Chat with a Lyricist", description: "We hop on a video call where you tell us who the song is for, what vibe you want, and any must-have details." },
  { icon: <Edit fontSize="large" />, title: "Lyrics in 48 Hours", description: "We turn your story into a first draft of lyrics, like musical wizards but with fewer pointy hats." },
  { icon: <CheckCircle fontSize="large" />, title: "Up to 5 Tweaks", description: "You get five rounds of revisions to make sure the lyrics are exactly what you want—whether that means tiny tweaks or a full rewrite." },
  { icon: <MusicNote fontSize="large" />, title: "Music Magic Happens", description: "Once you approve the lyrics, our songwriters turn them into a fully produced, one-of-a-kind song." },
  { icon: <CloudUpload fontSize="large" />, title: "Enjoy & Share", description: "You get your song digitally, plus optional extras like a custom lyric card or even a Spotify upload so the world can hear your masterpiece." }
];

const Process = (props) => {

  return ( <>
    <Typography>
      It’s as easy as telling us your story and letting us do the hard part! Here’s how it works:
      <ol>
        {steps.map((step, index) => (
          <li>
            <b>{step.title}</b>
            {" - "}
            {step.description}
          </li>
        ))}
      </ol>
      That’s it! A song made just for you, without the stress of rhyming “love” with “dove” (unless you’re into that).
    </Typography>
  </> )
}

export default Process
